import {RtcError, type AccessTokenSource} from '@phonehq/rtc-core';

export interface MatrixTokenPort {
    currentToken(): string | null | undefined;
    revalidate(): Promise<string | null>;
}

export const createMatrixAccessTokenSource = (port: MatrixTokenPort): AccessTokenSource => ({
    async current() {
        const token = port.currentToken();
        if (!token) {
            throw new RtcError('unauthorized', 'Matrix session is not available');
        }
        return token;
    },
    async onUnauthorized() {
        try {
            const token = await port.revalidate();
            if (!token) {
                throw new RtcError('unauthorized', 'Matrix session is not available');
            }
        } catch (error) {
            throw error instanceof RtcError
                ? error
                : new RtcError('unauthorized', 'Matrix session could not be refreshed', {cause: error});
        }
    },
});
